<template>
  <div class="map-editor-model" v-if="state.modelLayers.length">
    <r-text type="caption" style="margin-bottom: 4px;">
      Список слоев
    </r-text>
    <div class="map-editor-model__container">
      <ul class="map-editor-model__list">
        <li
          @click="toggleEditingModelLayer(item.id)"
          :class="[
            'map-editor-model__item',
            state.id === item.id ? 'active' : ''
          ]"
          v-for="item in state.modelLayers"
          :key="item.id"
        >
          <div class="map-editor-model__info">
            <r-icon
              type="regular"
              name="layers-folder"
              :size="16"
              :color="state.id === item.id ? '#fff' : undefined"
              v-if="!item.loading"
            />
            <i class="el-icon-loading" v-else />
            <div class="map-editor-model__name">{{ item.name }}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["state"],
  methods: {
    toggleEditingModelLayer(payload) {
      this.$emit("toggle-editing-layer", payload);
    }
  }
};
</script>

<style lang="scss">
.map-editor-model {
  margin-top: 15px;
  color: var(--text_secondary) !important;

  &__container {
    border-radius: var(--border-radius);
    border: 1px solid transparent;
    max-height: 260px;
    overflow: auto;
    background-color: var(--bg_panel_primary) !important;
    border-color: var(--dividers_low_contrast) !important;
  }

  &__list {
    margin: 10px 0;
  }

  &__item {
    padding: 3px 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    &.active {
      background-color: var(--accent_primary) !important;
      color: var(--white_white) !important;
    }
  }

  &__visible {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    border-radius: var(--border-radius);
    border: 1px solid transparent;
    border-color: var(--dividers_low_contrast) !important;
    margin-left: 10px;
    position: relative;
    cursor: pointer;

    .el-icon-view {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 11px;
    }
  }

  &__info {
    display: flex;
    align-items: center;

    .r-icon {
      margin-right: 8px;
      width: auto;
    }

    .el-icon-loading {
      font-size: 16px;
      margin-right: 10px;
    }
  }

  &__name {
    font-size: 11px;
  }
}
</style>
